import React from 'react';

import { useHotel } from '@/hotel';

import YourStaySummary from '../components/YourStaySummary.component';
import { useBooking } from '../hooks';

interface YourStaySummaryContainerProps {
  bookingId: string;
  hotelSlug: string;
}

export const YourStaySummaryContainer = ({
  bookingId,
  hotelSlug,
}: YourStaySummaryContainerProps) => {
  const booking = useBooking({ bookingId, hotelSlug });
  const hotel = useHotel(hotelSlug);

  if (!booking || !hotel) {
    return null;
  }

  const image = booking.heroRoomImage || hotel.content.images.hero;

  return (
    <YourStaySummary
      hotelRoomImageSrc={image.source}
      hotelName={hotel.name}
      overallTotal={booking.firstTotalChargeBreakdown.grandTotal}
      bookingId={bookingId}
      hotelSlug={hotelSlug}
      hotelCurrency={hotel.payments.currencyCode}
      numberOfNights={booking.totalNumberOfNights}
      totalAverageNightlyAmountAfterTax={
        booking.totalAverageNightlyAmountAfterTax
      }
    />
  );
};
